<span *ngIf="status" class="status-pill {{ CarryoverUtils.getStatusClass(status) }}">
  {{ CarryoverUtils.getStatusLabel(status) }}
</span>
<span *ngIf="!status" class="status-pill">Unset</span>
